import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dayjs from 'dayjs';
import { Col, Flex, Form, Input, Row, Button, DatePicker, Select } from "antd";
import { PageHeader } from "../../components/PageHeader/PageHeader";
import { getCatalogSearch } from "./catalogSearchSlice";
import { buildQueryString, debounce } from "../../utils/helpers";
import { IconSearch } from "../../components/IconSearch/IconSearch";
import { SearchSelect } from "../../components/SearchSelect/SearchSelect";
import { find } from 'lodash';

import css from "../Dashboard/Dashboard.module.css";

export const CatalogSearchBox = ({onApply, onReset}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const selectRef = React.useRef(null);

  const [search, setSearch] = React.useState([]);
  const [searchValues, setSearchValues] = React.useState([]);
  const [endDate, setEndDate] = React.useState(dayjs());
  
  const reset = () => {
  	form.resetFields();
	setSearch([]);
	setSearchValues([]);
	setEndDate(dayjs());
	onReset();
  }
    
  const filterAndAdd = (results) => {
	 const addEntities = ['catalog', 'UPC']; 
	 let newEntitiesAdded = false;
	 let filteredResults = [], newSearch = [...search], newSearchValues = [...searchValues];
	 for(let row of results) {
		if(addEntities.includes(row.entity)) {
			if(!newSearch.includes(row.value)) {
				newEntitiesAdded = true;
				newSearch.push(row.value);
				newSearchValues.push(row);
			}
		}
		else {
			filteredResults.push(row);
		}
	 } 
	 if(newEntitiesAdded) {
		setSearch(newSearch);
		setSearchValues(newSearchValues); 
		form.setFieldsValue({
			search: newSearch
		})
		if (selectRef.current) {
			selectRef.current.blur();
		}
	 }
	 return filteredResults;
  }
  
  const getFormattedSearch = async(query) => {
	const values = await dispatch(getCatalogSearch({query}));
	const fullResults = Array.isArray(values.payload) ? values.payload.map(result=>({
		label: `${result.name} (${result.entity})`,
		value: `${result.name} (${result.entity})`,
		term: result.name,
		entity: result.entity
	})) : [];  
	return filterAndAdd(fullResults);
  }
  
  const handleDateChange = (date) => {
  	if(date) {
  		setEndDate(date);
  	} 
	else {
		setEndDate(dayjs());
	}
  };
  
  const isFilterSelected = () => {
	if(search.length == 0)
		return false;
	return true;
  }

  
  const prepareSearch = () => {
	  onApply({searchValues, endDate})
  }
  
  return (
	<Flex className={""} vertical>
	  <Form
		name="searchForm"
		style={{ marginTop: 10, marginBottom: 0 }}
		initialValues={{ remember: true, endDate }}
		autoComplete="off"
		form={form}
	  >
		<Row gutter={16} className={css.searchFormContainer}>
		  <Col xs={24} md={24} lg={12} xxl={10} className={css.formItem}>
				<label htmlFor="search">Search:</label>
				<Form.Item name="search">
					<SearchSelect
						mode="multiple"
						value={search}
						placeholder="Search by Catalogue Number, UPC, Label, Artist and Title"
						fetchOptions={getFormattedSearch}
						onChange={(newValue, selected) => {
							setSearch(newValue);
							setSearchValues(selected);
						}}
						style={{
							width: '100%',
						}}
						selectRef={selectRef}
						//className="select-search"
					/>
				</Form.Item>
		  </Col>
		  <Col xs={24} md={24} lg={6} xxl={6} className={css.formItem}>
				<label htmlFor="range">Report Date Ending:</label>
		  	<Form.Item name="endDate">
		  		<DatePicker 
				  	picker="month"
			  		size={"large"}
			  		value={endDate}
					format="YYYY-MM" 
			  		onChange={handleDateChange}
		  		/>
		  	</Form.Item>
		  </Col>
		  <Col xs={24} md={24} lg={6} xxl={4} className={css.actionsWrapper}>
				{isFilterSelected() && <Button type="default" htmlType="submit" onClick={()=>reset()}>
					Clear Selection
				</Button>}
				<Button type="primary" htmlType="submit" onClick={()=>prepareSearch()}>
					{isFilterSelected() ? 'Apply' : 'Load All'}
				</Button>
		  </Col>
		</Row>
	  </Form>
	</Flex>
  );
};
